import { render, staticRenderFns } from "./selBranch.vue?vue&type=template&id=29fe8ea1&scoped=true&"
import script from "./selBranch.vue?vue&type=script&lang=js&"
export * from "./selBranch.vue?vue&type=script&lang=js&"
import style0 from "./selBranch.vue?vue&type=style&index=0&id=29fe8ea1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fe8ea1",
  null
  
)

export default component.exports